import ArticleComponent from './Article';

export default ArticleComponent;
